import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MostPopularCourses from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import {
  MostPopularCoursesNavbar,
  BackHeader,
  SideMenu,
} from "./../../components";
import { useNavigate, useLocation } from "react-router-dom";
let MostPopularTutors = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let CardData = [
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
  ];
  return (
    <div>
      {location.state.type === "unauthorized" ? (
        <div>
          <MostPopularCoursesNavbar />
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Most Popular tutors</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                      <div className="tutors-card-main">
                        <img
                          src={MostPopularCourses}
                          className="tutors-card-image"
                        />
                        <h1 className="tutors-card-heading">Melina Bauer</h1>
                        <p className="tutors-card-email">MiaEder@gmail.com</p>
                        <Button
                          className="view-details-button"
                          variant="text"
                          onClick={() => {
                            navigate("/most-popular-tutors/details", {
                              state: { type: location.state.type },
                            });
                          }}
                        >
                          view details
                        </Button>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </div>
      ) : (
        <SideMenu>
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Most Popular tutors</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                      <div className="tutors-card-main">
                        <img
                          src={MostPopularCourses}
                          className="tutors-card-image"
                        />
                        <h1 className="tutors-card-heading">Melina Bauer</h1>
                        <p className="tutors-card-email">MiaEder@gmail.com</p>
                        <Button
                          className="view-details-button"
                          variant="text"
                          onClick={() => {
                            navigate("/most-popular-tutors/details", {
                              state: { type: location.state.type },
                            });
                          }}
                        >
                          view details
                        </Button>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </SideMenu>
      )}
    </div>
  );
};
export default MostPopularTutors;
